import React from "react"
import { PageDrawerAction } from "src/components/ui/PageDrawerAction"
import { Icons } from "src/components/ui/Icons"
import { useActions, useAppState } from "src/state"
import { ThreadFragment } from "src/state/gql/_types"
import { FormDrawer } from "src/components/forms/FormDrawer"
import { 
    SuperAdminThreadCreateFragment, 
    SuperAdminThreadCreateSchema
} from "src/components/superadmin/threads/SuperAdminThreadSchemas"
import { toPgUuidArrayLiteral } from "src/utils/string"

type FormPayloadType = SuperAdminThreadCreateFragment

let initialState: FormPayloadType = {
    body: "",
    subject: "",
    recipient_ids: ""
};

export const CreateSuperAdminThreadDrawer: React.FC<{onClose():void}> = ({ onClose }) => {

    const { createThreadWithMessage, updateItem, deleteItem } = useActions().threads;
    const { loading, errors } = useAppState().threads;
    
    let currentItemId = null;
    let currentItemData: FormPayloadType | null = null;

    const handleCreate = (payload: FormPayloadType) => {
        const {body, subject } = payload;
        let data = { 
            body,
            subject,
            recipient_ids: toPgUuidArrayLiteral(payload.recipient_ids),
            idempotency_key: crypto.randomUUID(),
            message_type: "text",
            thread_type: "discussion",
            departments: "{}"
        }
        return createThreadWithMessage(data)
    }

    return (
        <>
            <FormDrawer<FormPayloadType, ThreadFragment, string>
                autoOpen={false}
                formSchema={SuperAdminThreadCreateSchema}
                createAction={handleCreate}
                updateAction={updateItem}
                deleteAction={deleteItem}
                isLoading={loading}
                errors={errors}
                currentItemId={currentItemId}
                initialData={initialState}
                currentItemData={currentItemData}
                onClose={onClose}
                deleteRedirect={true}
            />

        </>
    )

}

export const CreateSuperAdminThreadAction = () => {
    return (
        <PageDrawerAction<ThreadFragment>
            title='Add Thread'
            action={CreateSuperAdminThreadDrawer}
            icon={Icons.add}
        />
    )
}